import React, { useEffect, useCallback } from 'react';
import axios from 'axios';
import * as d3 from 'd3';

const FetchData = React.memo(({ route, setData, timeKeyField = "time_key", timeFormat = "%Y%m%d%H%M", processData, startDate, endDate }) => {
 
  const processLine = useCallback(
    (line) => {
      const parsedDate = d3.timeParse(timeFormat)(line[timeKeyField]);
     
      const baseData = {
        ...line,
        date: parsedDate !== null ? parsedDate : null,
      };
      
      return processData ? processData(baseData) : baseData;

    },
    [timeFormat, timeKeyField, processData]
  );

  useEffect(() => {
    if (!startDate || !endDate) {
      console.error("Start date and end date are required to fetch data.");
      return;
    }

    // Adjust hours to 00 and format dates
    const formatDate = d3.timeFormat("%Y%m%d%H%M");
    const adjustToStartOfHour = (date) => {
      
      const adjustedDate = new Date(date);
     
      adjustedDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0
      
      return adjustedDate;
    };

    const formattedStartDate = formatDate(adjustToStartOfHour(startDate));
    const formattedEndDate = formatDate(adjustToStartOfHour(endDate));

   
    axios
      .get(route, { params: { startDate: formattedStartDate, endDate: formattedEndDate } })
      .then((response) => {


        const dataLines = response.data;
        
        const processedData = dataLines
          .map(processLine)
          .filter((d) => {
            const isValid = d.date !== null && !isNaN(d.date.getTime());
            if (!isValid) {
              console.warn("Filtered out invalid data:", d); // Debug log
            }
            return isValid;
          });
       
        
          setData(processedData);
      })
      .catch((error) => {
        if (error.response) {
          console.error(`Server responded with status ${error.response.status}:`, error.response.data);
        } else if (error.request) {
          console.error("No response received from server:", error.request);
        } else {
          console.error("Error:", error.message);
        }
      });
  }, [route, startDate, endDate, processLine, setData]);

  return null;
});

export default FetchData;